import { memo } from 'react';

import { SubstanceSummaryResult } from '@/types/substanceSummary';
import MetricCard from '@/ui/components/MetricCard';

interface Props {
  result: SubstanceSummaryResult;
  index: number;
}

const SubstanceTrackerMetrics = ({ result, index }: Props) => {
  return (
    <section key={index} className="cursor-default flex gap-2 justify-center text-2xl w-full">
      <MetricCard
        key={`${index}-current_sober_streak`}
        icon={undefined}
        metricName={'Current Sobriety Streak'}
        metricValue={result.current_sober_streak}
      />
      <MetricCard
        key={`${index}-longest_sober_streak`}
        icon={undefined}
        metricName={'Longest Sobriety Streak'}
        metricValue={result.longest_sober_streak}
      />
      <MetricCard
        key={`${index}-current_log_streak`}
        icon={undefined}
        metricName={'Total Reported Sober days'}
        metricValue={result.total_reported_sober_days}
      />
    </section>
  );
};

export default memo(SubstanceTrackerMetrics);
